import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import EmpDashboard from "./dashboard/empdashboard";
import RequestLeaveForm from "./components/RequestLeaveForm";
import AllLeaves from "./components/AllLeaves";
import AdminDashboard from "./dashboard/AdminDashboard";
import ApproveLeaveRequests from "./components/ApproveLeaveRequests";
import AddEmployee from "./components/AddEmployee";
import AllEmployees from "./components/AllEmployees";
import EditEmployee from "./components/EditEmployee";
import UploadDocuments from "./components/UploadDocs";
import TrainingForm from "./components/CertificationForm";
import DepartmentForm from "./masters/Department";
import DesignationForm from "./masters/Designation";
import LeaveTypeForm from "./masters/Leave";
import DocumentCRUD from "./masters/Document";
import UploadDocument from "./components/UploadDocuments";
import ViewDocuments from "./components/ViewDocuments";
import RoleCRUD from "./masters/Roles";
import EditProfile from "./components/EditProfile";
import ManagerDashboard from "./dashboard/ManagerDashboard";
import ViewTasks from "./components/ViewTasks";
import RegisterEmployee from "./dashboard/RegisterEmployee";
import ManageUsers from "./dashboard/ManageUsers";
import LeaveList from "./components/LeaveList";
import HRDashboard from "./dashboard/HRDashboard";
import AssignLeaves from "./components/AssignLeaves";
import ViewLeaveCreditLogs from "./components/ViewLeaveCreditLogs";
import AdminDocuments from "./components/AdminDocuments";
import ViewTaskss from "./components/ViewTaskss";
import AdminViewTasks from "./dashboard/AdminViewTasks";
import AdminReports from "./dashboard/AdminReports";
import TimesheetGrid from "./components/TimesheetGrid";
import AdminTimesheetGrid from "./dashboard/AdminTimesheetGrid";
import ManagerTimesheetGrid from "./dashboard/ManagerTimesheetGrid";
import HRLetterGenerator from "./dashboard/HRLetterGenerator";
import KanbanBoard from "./dashboard/KanbanBoard";
import EmployeeFacilities from "./components/EmployeeFacilities";
import ManagerFacilities from "./components/ManagerFacilities";
import AdminFacilities from "./components/AdminFacilities";
import AdminProfile from "./dashboard/AdminProfile";
import TeamTimesheetGrid from "./dashboard/TeamTimesheetGrid";
import AdminNavbar from "./Layout/AdminNavbar";
import EmployeeView from "./components/ViewEmployee";
import ProtectedRoute from "./ProtectedRoute";
import EmpProtectedRoute from "./EmpProtectedRoute";
import SettingsPage from "./components/SettingsPage";
import EmployeeNavbar from "./Layout/EmployeeNavbar";
import EmpSettingPage from "./components/EmpSettingPage";
import ViewDetails from "./components/ViewDetails";
import TeamCRUD from "./masters/Team";
import ProjectCRUD from "./masters/Project";
import ManagerNavbar from "./Layout/ManagerNavbar";
import TeamPage from "./components/TeamPage";
import ManagerTeamLeaves from "./components/ManagerTeamLeaves";
import ManagerSettings from "./components/ManagerSettings";
// import ManageTeam from "./components/ManageTeam";
import AdminManageTeams from "./components/AdminManageTeams";
import ForgotPasswordModal from "./components/ForgotPasswordModal";
import Holiday from "./masters/Holiday";
import EmployeeHolidayPage from "./components/EmployeeHolidayPage";
import ManagerProfile from "./components/ManagerProfile";
import MastersLandingPage from "./admin/MastersLandingPage";
import EmployeeLandingPage from "./admin/EmployeeLandingPage";
import TasksLandingPage from "./admin/TasksLandingPage";
import TimesheetsLandingPage from "./admin/TimesheetsLandingPage";
import LeaveManagementLandingPage from "./admin/LeaveManagementLandingPage";
import ManagerTaskLanding from "./manager/ManagerTaskLanding";
import ManagerTimesheetLanding from "./manager/ManagerTimesheetLanding";
import ManagerLeaveLanding from "./manager/ManagerLeaveLanding";
import ManagerTeamLanding from "./manager/ManagerTeamLanding";
import EmployeeTaskLanding from "./employee/EmployeeTaskLanding";
import EmployeeTimesheetLanding from "./employee/EmployeeTimesheetLanding";
import EmployeeDocumentsLanding from "./employee/EmployeeDocumentsLanding";
import EmployeeLeavesLanding from "./employee/EmployeeLeavesLanding";
import EmployeeDetailsLanding from "./employee/EmployeeDetailsLanding";
import PendingLeaveList from "./components/PendingLeaveList";
import PendingManagerTeamLeaves from "./components/PendingManagerTeamLeaves";
import AllTimesheetGrid from "./components/AllTimesheetGrid";
import EmployeeAssetRequest from "./assetsmanagement/EmpAssets";
import EmployeeProjectsPage from "./tasklayout/EmployeeProjectsPage";
import LeaveManagement from "./components/LeaveManagement";
import ManagerLeaveAppli from "./components/ManagerLeaveAppli";
import ManagerLeaves from "./components/ManagerLeaves";
import ManagerTimesheet from "./components/ManagerTimesheet";
import ManagerDocumentLanding from "./manager/ManagerDocumentLanding";
import ManagerUploadDocs from "./components/ManagerUploadDocs";
import ManagerDocs from "./components/ManagerDocs";
import ManagerDetailsLanding from "./manager/ManagerDetailsLanding";
import ManagerViewDetails from "./components/ManagerViewDetails";
import ManagerHolidayPage from "./components/ManagerHolidayPage";
// import ATasks from "./dashboard/ATasks";
// import UTasks from "./components/UTasks";
// import MTasks from "./components/MTasks";
import AllocationPage from "./components/AllocationPage";
import Tasks from "./components/Tasks";
import Preference from "./components/Preference";
import TermsConditions from "./masters/TermsConditions";
import BalsuiteApp from "./components/Balsuite";
import EmployeeEvaluation from "./components/EmployeeEvaluation";
import AdminIntegrationConfig from "./components/AdminIntegrationConfig";
import IntegrationLandingPage from "./admin/IntegrationLandingPage";
import AdminPermissions from "./permissions/AdminPermissions";
import Announcement from "./announcement/Announcement";
import AlertsLanding from "./announcement/AlertsLanding";
import PermissionsLandingPage from "./admin/PermissionsLandingPage";
import CustomerManagement from "./masters/CustomerManagement";
import AllProjects from "./project/AllProjects";
import NewProject from "./project/NewProject";
import EditProject from "./project/EditProject";
import ViewProject from "./project/ViewProject";
import AllCustomers from "./customer/AllCustomers";
import NewCustomer from "./customer/NewCustomer";
import EditCustomer from "./customer/EditCustomer";
import ViewCustomer from "./customer/ViewCustomer";
import ListLandingPage from "./admin/ListLandingPage";
import SetupLandingPage from "./admin/SetupLandingPage";
import AllContacts from "./customer/AllContacts";
import EditContact from "./customer/EditContact";
import ViewContact from "./customer/ViewContact";
import NewContact from "./customer/NewContact";
// import AllSprints from "./sprint/AllSprints";
// import NewSprint from "./sprint/NewSprint";
// import EditSprint from "./sprint/EditSprint";
// import ViewSprint from "./sprint/ViewSprint";
// import SprintBacklog from "./sprint/SprintBacklog";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/empdashboard" element={<EmpProtectedRoute allowedRoles={["ROLE_USER"]}><EmpDashboard /></EmpProtectedRoute>} />
        <Route path="/leave" element={<RequestLeaveForm />} />
        <Route path="/allleaves" element={<AllLeaves />} />
        <Route path="/admindashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
        <Route path="/approveleave" element={<ApproveLeaveRequests />} />
        <Route path="/addemployee" element={<ProtectedRoute><AddEmployee /></ProtectedRoute>} />
        <Route path="/allemployee" element={<AllEmployees />} />
        <Route path="/editemployee/:id" element={<EditEmployee />} />
        <Route path="/uploaddocs" element={<UploadDocuments />} />
        <Route path="/certification" element={<TrainingForm />} />
        <Route path="/department" element={<DepartmentForm />} />
        <Route path="/designation" element={<DesignationForm />} />
        <Route path="/leavetype" element={<LeaveTypeForm />} />
        <Route path="/document" element={<DocumentCRUD />} />
        <Route path="/uploaddocuments" element={<UploadDocument />} />
        <Route path="/viewdocuments" element={<ViewDocuments />} />
        <Route path="/role" element={<RoleCRUD />} />
        <Route path="/editprofile" element={<EditProfile />} />
        <Route path="/managerdashboard" element={<ManagerDashboard />} />
        <Route path="/viewtasks" element={<ViewTasks />} />
        <Route path="/viewtaskss/:taskId" element={<ViewTaskss />} />
        <Route path="/viewtaskss" element={<ViewTaskss />} />
        <Route path="/registeremployee" element={<RegisterEmployee />} />
        <Route path="/manageusers" element={<ManageUsers />} />
        <Route path="/leavelist" element={<LeaveList />} />
        <Route path="/hrdashboard" element={<HRDashboard />} />
        <Route path="/assignleaves" element={<AssignLeaves />} />
        <Route path="/viewleavecredit" element={<ViewLeaveCreditLogs />} />
        <Route path="/viewalldocs" element={<AdminDocuments />} />
        <Route path="/adminviewtasks" element={<AdminViewTasks />} />
        <Route path="/adminreports" element={<AdminReports />} />
        <Route path="/timesheetgrid" element={<TimesheetGrid />} />
        <Route path="/task/:taskId" element={<ViewTasks />} />
        <Route path="/task/id" element={<ViewTasks />} />
        {/* <Route path="/viewtasks/tasks/:taskId/comments" element={<ViewTasks />} /> */}
        <Route path="/admintimesheetgrid" element={<AdminTimesheetGrid />} />
        <Route path="/managertimesheetgrid" element={<ManagerTimesheetGrid />} />
        <Route path="/managertimesheetgrid/:managerId" element={<ManagerTimesheetGrid />} />
        <Route path="/hrlettergenerator" element={<HRLetterGenerator />} />
        <Route path="/kanbanboard" element={<KanbanBoard />} />
        <Route path="/employeefacilities" element={<EmployeeFacilities />} />
        <Route path="/managerfacilities" element={<ManagerFacilities />} />
        <Route path="/adminfacilities" element={<AdminFacilities />} />
        <Route path="/adminprofile" element={<AdminProfile />} />
        <Route path="/teamtimesheetgrid" element={<TeamTimesheetGrid />} />
        <Route path="/teamtimesheetgrid/:managerId" element={<TeamTimesheetGrid />} />
        <Route path="/adminnavbar" element={<AdminNavbar />} />
        <Route path="/viewemployee/:id" element={<EmployeeView />} />
        <Route path="/settingpage" element={<SettingsPage />} />
        <Route path="/employeenavbar" element={<EmployeeNavbar />} />
        <Route path="/empsettingpage" element={<EmpSettingPage />} />
        <Route path="/viewdetails" element={<ViewDetails />} />
        <Route path="/team" element={<TeamCRUD />} />
        <Route path="/project" element={<ProjectCRUD />} />
        <Route path="/managernavbar" element={<ManagerNavbar />} />
        <Route path="/teampage" element={<TeamPage />} />
        <Route path="/managerteamleaves" element={<ManagerTeamLeaves />} />
        <Route path="/managersettings" element={<ManagerSettings />} />
        {/* <Route path="/manageteam" element={<ManageTeam />} /> */}
        <Route path="/adminmanageteams" element={<AdminManageTeams />} />
        <Route path="/forgotpassword" element={<ForgotPasswordModal />} />
        <Route path="/holiday" element={<Holiday />} />
        <Route path="/holidays" element={<EmployeeHolidayPage />} />
        <Route path="/managerprofile" element={<ManagerProfile />} />
        <Route path="/masterslanding" element={<MastersLandingPage />} />
        <Route path="/employeelanding" element={<EmployeeLandingPage />} />
        <Route path="/admintasklanding" element={<TasksLandingPage />} />
        <Route path="/admintimesheetlanding" element={<TimesheetsLandingPage />} />
        <Route path="/adminleavemanagementlanding" element={<LeaveManagementLandingPage />} />
        <Route path="/managertasklanding" element={<ManagerTaskLanding />} />
        <Route path="/managertimesheetlanding" element={<ManagerTimesheetLanding />} />
        <Route path="/managerleavelanding" element={<ManagerLeaveLanding />} />
        <Route path="/managerteamlanding" element={<ManagerTeamLanding />} />
        <Route path="/employeetasklanding" element={<EmployeeTaskLanding />} />
        <Route path="/employeetimesheetlanding" element={<EmployeeTimesheetLanding />} />
        <Route path="/employeedocumentslanding" element={<EmployeeDocumentsLanding />} />
        <Route path="/employeeleavelanding" element={<EmployeeLeavesLanding />} />
        <Route path="/employeedetailslanding" element={<EmployeeDetailsLanding />} />
        <Route path="/pendingleavelist" element={<PendingLeaveList />} />
        <Route path="/pendingmanagerteamleaves" element={<PendingManagerTeamLeaves />} />
        <Route path="/alltimesheetgrid" element={<AllTimesheetGrid />} />
        <Route path="/empassets" element={<EmployeeAssetRequest />} />
        <Route path="/empprojtask/:id" element={<EmployeeProjectsPage />} />
        <Route path="/adminviewtasks/:taskId" element={<AdminViewTasks />} />
        <Route path="/leavemanagement" element={<LeaveManagement />} />
        <Route path="/managerleaveappli" element={<ManagerLeaveAppli />} />
        <Route path="/managerleaves" element={<ManagerLeaves />} />
        <Route path="/managertimesheet" element={<ManagerTimesheet />} />
        <Route path="/managerdocumentlanding" element={<ManagerDocumentLanding />} />
        <Route path="/manageruploaddocs" element={<ManagerUploadDocs />} />
        <Route path="/managerdocs" element={<ManagerDocs />} />
        <Route path="/managerdetailslanding" element={<ManagerDetailsLanding />} />
        <Route path="/managerviewdetails" element={<ManagerViewDetails />} />
        <Route path="/mholidays" element={<ManagerHolidayPage />} />
        {/* <Route path="/atasks" element={<ATasks/>}/>
        <Route path="/utasks" element={<UTasks/>}/>
        <Route path="/mtasks" element={<MTasks/>}/> */}
        <Route path="/allocation" element={<AllocationPage />} />
        <Route path="/tasks" element={<Tasks />} />
        <Route path="/preference" element={<Preference />} />
        <Route path="/termconditions" element={<TermsConditions />} />
        <Route path="/balsuite" element={<BalsuiteApp />} />
        <Route path="/evaluation" element={<EmployeeEvaluation />} />
        <Route path="/teamworkint" element={<AdminIntegrationConfig />} />
        <Route path="/integrationlanding" element={<IntegrationLandingPage />} />
        <Route path="/permissions" element={<AdminPermissions />} />
        <Route path="/announcement" element={<Announcement />} />
        <Route path="/alertslanding" element={<AlertsLanding />} />
        <Route path="/permissionslanding" element={<PermissionsLandingPage />} />
        <Route path="/customermgmt" element={<CustomerManagement />} />
        <Route path="/allprojects" element={<AllProjects />} />
        <Route path="/addproject" element={<NewProject />} />
        <Route path="/editproject/:id" element={<EditProject />} />
        <Route path="/viewproject/:id" element={<ViewProject />} />
        <Route path="/allcustomers" element={<AllCustomers />} />
        <Route path="/addcustomer" element={<NewCustomer />} />
        <Route path="/editcustomer/:id" element={<EditCustomer />} />
        <Route path="/viewcustomer/:id" element={<ViewCustomer />} />
        <Route path="/listlanding" element={<ListLandingPage />} />
        <Route path="/setuplanding" element={<SetupLandingPage />} />
        <Route path="/allcontacts" element={<AllContacts />} />
        <Route path="/addcontact" element={<NewContact />} />
        <Route path="/viewcontact/:contactId" element={<ViewContact />} />
        <Route path="/editcontact/:contactId" element={<EditContact />} />
        {/* <Route path="/allsprints" element={<AllSprints />} />
        <Route path="/addsprint" element={<NewSprint />} />
        <Route path="/editsprint/:id" element={<EditSprint />} />
        <Route path="/viewsprint/:id" element={<ViewSprint />} />
        <Route path="/sprintbacklog" element={<SprintBacklog />} /> */}
      </Routes>

      {/* ToastContainer should be outside Routes */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
      />

    </Router>
  );
}

export default App;
